import MediaLibrary from "../upload/MediaLibrary";


class MediaList {
    constructor(element) {
        this.element = element;
        this.template = null;
    }

    registerTemplate(template, itemToMedia) {
        this.template = template;
        this.itemToMedia = itemToMedia;
        return this;
    }

    addFile(key, filename) {
        const templateHtml = this.fillTemplate(key, filename, "New");
        MediaLibrary.register(templateHtml);
        this.element.prepend(templateHtml);
    }

    fillTemplate(key, name, when) {
        const template = this.generateTemplate(key);
        return template.fill(this.itemToMedia(key, name, when));
    }

    generateTemplate(key) {
        if(this.template) {
            return this.template;
        }
        return null;
    }
}


export default MediaList;